import { normalizeUnternehmensform, UNTERNEHMENSFORM_MIETWAGEN } from './transportWording';

/**
 * Fahrpreismodus des Mandanten: Taxameter (Endpreis am Fahrtende) oder
 * Festpreis vorab (verbindlicher Serverpreis vor der Bestellung).
 *
 * Abgeleitet aus `appSettings/general.unternehmensform`, solange
 * `preismodell` nicht ausdrücklich auf 'taxameter' steht:
 *   mietwagen → festpreis_vorab,  taxi → taxameter.
 * Für Mietwagen ist der Festpreis Standard, aber keine Pflicht
 * (`preismodell: 'taxameter'` = Wegstreckenzähler, Ablauf wie bisher).
 * `preismodell: null` heißt „abgeleitet".
 *
 * Spiegelt nextcab_mobile/functions/src/shared/preismodell.ts und
 * lib/models/app_settings.dart — alle drei synchron halten.
 * Siehe nextcab_mobile/docs/general/mietwagen_festpreis_modus_konzept.md §4.
 */

export const PREISMODELL_TAXAMETER = 'taxameter';
export const PREISMODELL_FESTPREIS_VORAB = 'festpreis_vorab';

export const resolvePreismodell = (general) => {
  const data = general || {};
  if (normalizeUnternehmensform(data.unternehmensform) !== UNTERNEHMENSFORM_MIETWAGEN) {
    return PREISMODELL_TAXAMETER;
  }
  return data.preismodell === PREISMODELL_TAXAMETER ? PREISMODELL_TAXAMETER : PREISMODELL_FESTPREIS_VORAB;
};

export const isFestpreisVorab = (general) => resolvePreismodell(general) === PREISMODELL_FESTPREIS_VORAB;
